/**
 * The processing screen's steps, in order. The first one names what is being
 * read, so it follows what was attached; the rest are the same on every client.
 */
export const processingStepTitles = (fileCount: number): readonly string[] => [
	fileCount > 0 ? 'Reading documents' : 'Reading your notes',
	'Extracting events',
	'Matching to your trip days',
	'Adding to your itinerary',
]

/**
 * Elapsed-time thresholds (ms) at which the fake progress timer advances to the
 * next step. The backend doesn't report progress, so steps tick on a timer.
 */
const STEP_BOUNDARIES_MS = [3_000, 10_000, 45_000] as const

export const computeStepIndex = (elapsedMs: number): number => {
	let idx = 0
	for (const boundary of STEP_BOUNDARIES_MS) {
		if (elapsedMs >= boundary) idx += 1
	}
	return idx
}

/** How long an import can sit in Pending/Processing before we call it stuck. */
export const STUCK_THRESHOLD_MS = 10 * 60 * 1000
